<div class="innerpage-fullwithbanner">
  <h2 class="bighead">Data Entry performance Dashboard<span class="offerstatus">{{rowCount|number}}</span></h2>
  <ul class="bread-crumbs">
    <li><a (click)="Validation.redirect('/')">Home<span>|</span></a></li>
    <li>Opportunity<span style="padding:8px;">|</span></li>
    <li>Data Entry performance Dashboard</li>
  </ul>
</div>
<div class="featuredproperties section-margin">
  <div class="container container-lg min-heightcontainer">
    <div class="row">
      <div class="col-lg-12 ">
        <div class="border-div table-fixed margin0">
          <div class="floatinghead clearfix margin-bottom-10">
            <div class="row">
              <div class="leftside col-lg-6">
                <label class="form-label">Date Range</label>
                <div class="d-flex">
                  <div class="textbox-date margin-right-5">
                    <input class="form-control" [(ngModel)]="dateFromRange" type="text" placeholder="From" placement="bottom left" bsDatepicker>
                    <i class="icofont icofont-ui-calendar icon"></i>
                  </div>
                  <div class="textbox-date">
                    <input class="form-control" [(ngModel)]="dateToRange" type="text" placement="bottom left" placeholder="To" bsDatepicker>
                    <i class="icofont icofont-ui-calendar icon"></i>
                  </div>
                  <div class="btn-group d-flex">
                    <button type="button" (click)="onSearchBtn()" class="btn btn-success btn-lg" style="margin-right:20px">Search</button>
                    <button type="button" (click)="onResetBtn()" class="btn-lg btn-border btn adduserbtn">Reset</button>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="rightside clearfix">
                  <label class="form-label">&nbsp;</label>
                  <div class="search-sec">
                    <input class="form-control" (keyup)="onSearch($event.target.value)" type="text" placeholder="Search">
                    <i class="fa fa-search icon" aria-hidden="true"></i>
                  </div>
                  <button type="button" (click)="openHourlyLimit(ShareListing)" class="btn btn-success btn-lg">Set Hour Limit</button>
                </div>
              </div>
            </div>
           
           
          </div>
          <div class="table-responsive">
            <table class="table basictable row-border hover" datatable [dtOptions]="dtOptions">
              <thead>
                <tr>
                  <th class="min-width-td sticky-left z-100" style="width:250px;">Data Entry Staff</th>
                  <th>Weekly Hour Limit</th>
                  <th>Properties Rejected</th>
                  <th>Properties Approved</th>
                  <th>Properties Created</th>
                  <th>Properties Verified</th>
                  <th>Properties Info Modified</th>
                  <th>Properties Under Contract</th>
                  <th>Properties Not Available</th>
                  <th>Properties Available</th>
                  <th>Properties Viewed</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let user of users;let i = index ">
                  <td class="invited-user ">
                    <div style="display:table">
                      <p><b>{{ user.Name }}</b></p>
                      <p *ngIf="user.PhoneNumber">{{ user.PhoneNumber | phone }}</p>
                      <p *ngIf="user.UserName">{{user.UserName}}</p>
                    </div>
                  </td>
                  <td><p>{{user.WeeklyHourLimit}}</p></td>
                  <td><p>{{user.ProeprtiesRejected}}</p></td>
                  <td><p>{{user.PropertiesApproved}}</p></td>
                  <td><p>{{user.PropertiesCreated}}</p></td>
                  <td><p>{{user.PropertiesVerified}}</p></td>
                  <td><p>{{user.PropertiesModified}}</p></td>
                  <td><p>{{user.PropertiesUnderContract}}</p></td>
                  <td><p>{{user.PropertiesNotAvailable}}</p></td>
                  <td><p>{{user.PropertiesAvailable}}</p></td>
                  <td><p>{{user.PropertiesViewed}}</p></td>
                </tr>
              </tbody>
              <tfoot>
                <tr *ngIf="users?.length == 0&&!IsLoading ">
                  <td colspan="7" class="odd no-data-available">
                    <div class="nodata">
                      <i class="fa fa-exclamation-triangle icon"></i>
                      <p>No Data Available</p>
                    </div>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #ShareListing>
  <div class="modal-header">
    <h4 class="modal-title pull-left">
      Set Hour Limit
    </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="onClose();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form #contactForm="ngForm">
      <div class="form-group">
        <label class="form-label">Select Data entry Staff <span class="star">*</span> </label>
        <label class="select">
          <select name="cmbBroker" required [(ngModel)]="hourInputModel.DataEntryStaffid"
                  #cmbBroker="ngModel"  (change)="getSelectedUserHourLimit()"
                  class="form-control ">
            <option value="0" selected>Select</option>
            <option *ngFor="let des of dataentrystafflst" [(ngValue)]="des.Id">{{des.Name}}</option>
          </select>
        </label>
        <div *ngIf="((Validation.IsinValid(hourInputModel.DataEntryStaffid) && isSubmit) || (cmbBroker.invalid && cmbBroker.touched))">
          <p class="redtext">Data Entry Staff is required </p>
        </div>
      </div>
      <div class="form-group">
        <label class="form-label">
          Enter Hours <span class="star">*</span>
        </label>
        <input type="text" name="txtHours" #txtHours="ngModel" [min]="0" mask="9999999999"
               [dropSpecialCharacters]="false" [required]="Hours" maxlength="100" [(ngModel)]="hourInputModel.Hours" class="form-control ">
        <div *ngIf="((Validation.IsinValid(hourInputModel.Hours) && isSubmit) || (txtHours.invalid && txtHours.touched))">
          <p class="redtext">Hours is required </p>
        </div>
      </div>
      <!--<div class="form-group">
        <label class="form-label">Date Range  <span class="star">*</span></label>
        <div class="textbox-date">
          <input class="form-control" name="txtFromDate" #txtFromDate="ngModel" [(ngModel)]="hourInputModel.DateFromRange" type="text" placeholder="From" placement="bottom left" bsDatepicker>
          <i class="icofont icofont-ui-calendar icon"></i>
        </div>
        <div *ngIf="((Validation.IsinValid(hourInputModel.DateFromRange) && isSubmit) || (txtFromDate.invalid && txtFromDate.touched))">
          <p class="redtext">From Date is required </p>
        </div>
      </div>
      <div class="form-group">
        <label class="form-label hide480">&nbsp;</label>
        <div class="textbox-date">
          <input class="form-control" name="txtToDate" #txtToDate="ngModel" [(ngModel)]="hourInputModel.DateToRange" type="text" placement="bottom left" placeholder="To" bsDatepicker>
          <i class="icofont icofont-ui-calendar icon"></i>
        </div>
        <div *ngIf="((Validation.IsinValid(hourInputModel.DateToRange) && isSubmit) || (txtToDate.invalid && txtToDate.touched))">
          <p class="redtext">To Date is required </p>
        </div>
      </div>-->
    </form>

    <div class="text-right">
      <button type="button" (click)="onClose()" class="btn btn-default btn-lg">Cancel</button>
      <button type="button" (click)="saveHours();" class="btn btn-success btn-lg">Save</button>
    </div>
  </div>
</ng-template>

